module.exports = __webpack_public_path__ + "static/media/Movingful-MWDG-Final-FC.b387a52f.svg";